import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, Inject, EventEmitter, Output } from '@angular/core';
import { ActiviteService } from 'src/app/shared/services/simple/activite.service';
import { ActiviteModel, ActiviteNode } from 'src/app/shared/models/simple-types/activite.model';
import { GestionActiviteComponent } from 'src/app/core/gestion-referentiel/gestion-activite/gestion-activite.component';
import { ModalStructureActiviteComponent } from '../modal-structure-activite/modal-structure-activite.component';

export interface DialogData {
  form: UntypedFormGroup;
  activite: ActiviteModel;
  activites: ActiviteModel[];
  result: boolean;
}
@Component({
  selector: 'app-modal-add-activite',
  templateUrl: './modal-add-activite.component.html',
  styleUrls: ['./modal-add-activite.component.scss']
})
export class ModalAddActiviteComponent implements OnInit {
  @Output() onUpdated = new EventEmitter<boolean>();
  activites: ActiviteModel[];
  form: UntypedFormGroup;
  constructor(public dialog: MatDialog,
            public dialogRef: MatDialogRef<ModalStructureActiviteComponent>,
            @Inject(MAT_DIALOG_DATA) public data: DialogData,
            private toastr: ToastrService,
            private activiteService: ActiviteService) {
             }


    ngOnInit(): void {
      this.activites = this.data.activites;
      this.form = this.data.form;
    }

    onModalCancel(): void {
      this.data.result = false;
      this.dialogRef.close(false);
    }

    onModalConfirm(): void {
      if (this.form.valid) {
        const activite = this.form.getRawValue();
        // Création
        if (!this.form.get('id').value){
          const dialogRef = this.dialog.open(SpinnerModalComponent);
            this.activiteService.save(activite).subscribe((a: ActiviteModel) => {
              this.toastr.success('', 'Création de l\'activité ' + a.code + ' réussie');
              this.dialogRef.close(true);
              dialogRef.close();
            }, (error) => {
              this.dialogRef.close(true);
              dialogRef.close();
            });
        }else { // Modification
          const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.activiteService.update(activite.id, activite).subscribe((a: ActiviteModel) => {
            this.toastr.success('', 'Modification de l\'activité ' + a.code + ' réussie');
            this.dialogRef.close(a);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(false);
            dialogRef.close();
          });
        }
      } else {
        this.displayErrors();
      }
   }

   displayErrors(): void {
    for (const index in this.form.controls) {
      if (index && (this.form.controls[index].hasError('required') || this.form.controls[index].hasError('max'))) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}



